/**
 * KPI card for the Originator redesign.
 *
 * `trend` and `subline` are optional and only render when supplied — so the
 * same card works today (value only) and later when backend trend deltas land
 * (Category C2), with no contract change.
 */
function TrendBadge({ trend }) {
  if (!trend || trend.value === undefined || trend.value === null) return null;
  const dir = trend.direction || (trend.value >= 0 ? 'up' : 'down');
  const isUp = dir === 'up';
  const tone = isUp
    ? 'bg-emerald-50 text-emerald-700'
    : 'bg-rose-50 text-rose-700';
  return (
    <span
      className={`inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-[10px] font-semibold ${tone}`}
    >
      <span aria-hidden>{isUp ? '▲' : '▼'}</span>
      {trend.value}
    </span>
  );
}

export function KpiCard({
  label,
  value,
  subline,
  trend,
  icon: Icon,
  loading = false,
  accent = false,
}) {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-eorig-border bg-white p-4 shadow-eorig-card">
      {accent ? (
        <span
          className="absolute inset-x-0 top-0 h-1 bg-eorig-gradient"
          aria-hidden
        />
      ) : null}
      <div className="flex items-start justify-between gap-2">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-eorig-muted">
          {label}
        </p>
        {Icon ? (
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-eorig-surface text-eorig-navy-600">
            <Icon className="h-4 w-4" />
          </span>
        ) : null}
      </div>
      <div className="mt-2 flex items-end gap-2">
        <p className="text-2xl font-bold tabular-nums tracking-tight text-eorig-ink">
          {loading ? '—' : value}
        </p>
        {!loading ? <TrendBadge trend={trend} /> : null}
      </div>
      {subline ? (
        <p className="mt-1 text-[11px] leading-snug text-eorig-muted">{subline}</p>
      ) : null}
    </div>
  );
}
